module.exports = __webpack_public_path__ + "img/boky_81_reflexni-cervena.6d9212c3.png";